export function getPercentage(min, max, value) {
    min = Number(min)
    max = Number(max)
    value = Number(value)
    if (max === min) return 0
    return Math.round(((value - min) / (max - min)) * 100);
}